<template>
    <div class="highWork">
        <div class="banner"></div>
        <div class="content1">
            <div class="con">
                <p class="p1">钉钉高级版工作台</p>
                <p class="line"></p>
                <p class="p2">打造企业“云端办公室”</p>
                <div class="box1">
                    <p class="p3">什么是高级版工作台？</p>
                    <p class="p4">重点针对中小型企业，根据中小型企业特征，进行价值重新定位和版本拆分。目标为中小企业提供一揽子“轻量+适配型+专业化”工作台方案，助力中小企业用好钉钉，升级数字化办公效率。</p>
                </div>
                <ul class="ul-s">
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/89ab2090-d3a4-402c-86dc-9413cdaef17d.png?tenantId=214689&viewType=1&k=1655780814000" alt="">
                        <p>统一应用入口，打破信息孤岛；</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/18360f35-54ad-435f-9be3-e1aa4ae0b2c1.png?tenantId=214689&viewType=1&k=1655780814000" alt="">
                        <p>可以针对企业需要快速对门户进行配置展示，让企业员工感受到企业文化</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/2f241b00-bf9a-4499-9c96-0710a7a41d63.png?tenantId=214689&viewType=1&k=1655780814000" alt="">
                        <p>海量精选模板；预置服务商的标准行业经验模板；</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/c0c1cd6c-582c-418b-aa34-a6e1eafe9cd6.png?tenantId=214689&viewType=1&k=1655780814000" alt="">
                        <p>0代码交付、轻量适配、快速复制；</p>
                    </li>
                </ul>
        </div>
        </div>
        <div class="content2">
            <div class="con2">
                <p class="p1">普通版/高级版工作台区别</p>
                <div class="liubai"></div>
                <ul class="ul-s2">
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/c0fb0fe1-f1ff-4da1-8f03-f1e3279822f8.png?tenantId=214689&viewType=1&k=1655780814000" alt="">
                        <div class="box2 xx">
                            <p>普通版工作台</p>
                            <div class="btn">免费</div>
                            <div class="btn">比较散乱</div>
                            <div class="btn">无行业专属感</div>
                        </div>
                    </li>
                    <li>
                        <img src="./img-home/ssdds.png" alt="" class="img-ssd">
                        <div class="box2 xx">
                            <p>高级版工作台</p>
                            <div class="btn btns">专业模板</div>
                            <div class="btn btns">行业组件</div>
                            <div class="btn btns">轻量适配</div>
                            <div class="btn btns">快速交付</div>
                            <div class="btn btns">零代码</div>
                        </div>
                    </li>
                </ul>
                <div class="liubai"></div>
                <p class="p1">普通版/高级版工作台组件差异</p>
                <div class="liubai"></div>
                <ul class="ss">
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/4d3785f5-8222-434b-8e08-53ca9466b8c1.png?tenantId=214689&viewType=1&k=1655780814000" alt="">
                        <p>普通版工作台</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/87420f0e-2ed4-4cad-9382-fc27815e77dc.png?tenantId=214689&viewType=1&k=1655780814000" alt="">
                        <p>高级版工作台</p>
                    </li>
                </ul>
            </div>
            <div class="lllbai"></div>
        </div>
        <div class="content3">
            <div class="con3">
                <p class="p1">模板中心</p>
                <div class="liubai"></div>
                <ul class="ul-moban">
                    <li><img src="http://img601.yun300.cn/repository/image/f7b449ff-0377-4ec5-b4e1-956bbe060bfa.jpg?tenantId=214689&viewType=1&k=1655780814000" alt=""></li>
                    <li><img src="http://img601.yun300.cn/repository/image/314183b2-012f-4f0d-a0ac-b41485bdd386.jpg?tenantId=214689&viewType=1&k=1655780814000" alt=""></li>
                    <li><img src="http://img601.yun300.cn/repository/image/8faafce2-3101-412d-9229-6e8ba4f639d6.jpg?tenantId=214689&viewType=1&k=1655780814000" alt=""></li>
                    <li><img src="http://img601.yun300.cn/repository/image/a1fedc56-c7a9-464b-acc2-61fc06a61d2a.jpg?tenantId=214689&viewType=1&k=1655780814000" alt=""></li>
                    <li><img src="http://img601.yun300.cn/repository/image/2227c9c9-642f-4213-af6f-268ebc8d01d8.jpg?tenantId=214689&viewType=1&k=1655780814000" alt=""></li>
                    <li><img src="http://img601.yun300.cn/repository/image/ba73df7e-3ccd-4746-ada8-7f663256b768.jpg?tenantId=214689&viewType=1&k=1655780814000" alt=""></li>
                </ul>
            </div>
        </div>
    </div>
</template>
        
<script>
export default {
   mounted () {
    document.querySelector
   }
}
</script>
<style lang='less' scoped>
.highWork{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/jjfa_gjgzt_1920337.5@1x.png);
        background-size: 100%;
        background-repeat: no-repeat;
    }
    .content1{
        width: 100%;
        background-color: #fff;
        .con{
            width:80%;
            margin: auto;
            padding-top: 40px;
            position: relative;
            .p1{
                font-size: 35px;
                text-align: center;
                color: #000;
            }
            .line{
                width: 80px;
                height: 4px;
                background-color: rgba(0, 137, 255, 1);
                margin: 30px auto;
            }
            .p2{
                font-size: 38px;
                color: #000;
                text-align: center;
                margin-bottom: 50px;
            }
            .box1{
                width: 100%;
                background-color: rgba(69, 142, 254, 1);
                padding: 40px 60px;
                border-radius: 6px;
                margin-bottom: 180px;
                padding-bottom: 170px;
                
                .p3{
                    font-size: 32px;
                    color: #fff;
                    text-align: center;
                    margin-bottom: 20px;
                }
                .p4{
                    font-size: 22px;
                    line-height: 1.8;
                    color: #fff;
                }
                
            }
            .ul-s{
                    width: 100%;
                    position: absolute;
                    bottom: -100px;
                    z-index: 2;
                    display: flex;
                    justify-content: space-evenly;
                    li{
                        width: 20%;
                        padding: 40px;
                        background-color: #fff;
                        border-radius: 6px;
                        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 4px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        img{
                            width: 70px;
                            height: 70px;
                            margin-bottom: 15px;
                        }
                        p{
                            line-height: 24px;
                            margin-top: 10px;
                        }
                    }
                }
        }
    }
    .content2{
        width: 100%;
        background-color: rgba(250, 250, 250, 1);
        .con2{
            width: 80%;
            margin: auto;
            padding-top: 40px;
            .p1{
                font-size: 35px;
                text-align: center;
                color: #000;
            }
            .liubai{
                height: 40px;
            }
            .ul-s2{
                width: 100%;
                height: 600px;
                
                display: flex;
                li{
                    width: 50%;
                    height: 100%;
                    background-color: #fff;
                    display: flex;
                    img{
                        width: 40%;
                        height: 600px;
                    }
                    .img-ssd{
                        width: 38%;
                        height: 580px;
                        margin-right: 10%;
                    }
                    .box2{
                        width: 50%;
                        height: 100%;
                        padding-top: 70px;
                        p{
                            font-size: 18px;
                            color: #000;
                            margin-bottom: 30px;
                        }
                        .btn{
                            width: 50%;
                            background-color: rgba(170, 170, 170, 1);
                            border-radius: 4px;
                            margin-bottom: 20px;
                            color: #fff;
                            text-align: center;
                            padding: 15px;
                        }
                        .btns{
                            background-color: rgba(69, 142, 254, 1);
                        }
                    }
                }
            }
            .ss{
                width: 100%;
                display: flex;
                li{
                    width: 50%;
                    padding: 40px 10px;
                    height: 100%;
                    background-color: #fff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    img{
                        width: 400px;
                        height: 550px;
                    }
                    p{
                        width: 100%;
                        height: 10%;
                        padding-top: 20px;
                        text-align: center;
                    }
                }
            }
        }
        .lllbai{
            height: 50px;
        }
    }
    .content3{
        width: 100%;
        background-color: #fff;
        .con3{
            width: 80%;
            margin: auto;
            padding-top: 40px;
            .p1{
                font-size: 35px;
                text-align: center;
                color: #000;
            }
            .liubai{
                height: 40px;
            }
            .ul-moban{
                width: 100%;
                display: flex;
                justify-content: space-around;
                flex-wrap: wrap;
                li{
                    width: 30%;
                    padding: 30px 50px;
                    img{
                        width: 100%;
                        height: 800px;
                    }
                }
            }
        }
    }
    
}
</style>